// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.7a46de823',
  revision: '7a46de823',
  branch: 'develop',
  date: 'Wed, 12 Aug 2026 06:03:23 GMT'
};